module.exports = __webpack_public_path__ + "img/naranja.98cfad7d.jpg";